/**
 * Locale Interceptor
 * Автоматическое добавление заголовка user-locale для получения локализованного контента
 */
import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios'
import { i18n } from '@/i18n'

export function setupLocaleInterceptor(axiosInstance: AxiosInstance) {
  // Request interceptor - добавление заголовка user-locale
  axiosInstance.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      // Получаем текущую локаль из i18n
      const global = i18n.global as unknown as { locale: { value: string } }
      const currentLocale = global.locale.value

      // DEV-972: не затираем локаль, если запрос уже выставил её явно (напр. refetch
      // ЖК на языке клиента для «поделиться объектом»). По умолчанию — UI-локаль.
      if (currentLocale && config.headers && !config.headers['user-locale']) {
        config.headers['user-locale'] = currentLocale
      }

      return config
    },
    (error) => Promise.reject(error),
  )
}
